import { BrowserFeatureDetector } from "./BrowserFeatureDetector";

interface BrowserSpec {
  name: string;
  minVersion: number;
  device?: string;
  os?: string;
}

const supportedBrowsers: BrowserSpec[] = [
  { name: "chrome", minVersion: 50 },
  { name: "chromium", minVersion: 50 },
  { name: "edge", minVersion: 15 },
  { name: "firefox", minVersion: 50 },
  { name: "firefox", minVersion: 60, os: "XP" },
  { name: "ios", minVersion: 9 },
  { name: "ios", minVersion: 10, device: "iPhone" },
  { name: "webkit", minVersion: 601, device: "iPhone" },
  { name: "webkit", minVersion: 601, device: "iPad" },
  { name: "opera", minVersion: 36 },
  { name: "safari", minVersion: 9 },
  { name: "mobile safari", minVersion: 9 },
  { name: "samsung", minVersion: 7 },
  { name: "samsung browser", minVersion: 5 },
  { name: "android browser", minVersion: 4 },
  { name: "chrome webview", minVersion: 4 },
  { name: "gsa", minVersion: 60 },
  { name: "facebook", minVersion: 150 },
  { name: "ucbrowser", minVersion: 12 },
  { name: "vivaldi", minVersion: 2 },
  { name: "huawei browser", minVersion: 11 },
  { name: "miui browser", minVersion: 10 },
];

const isIOS9Supported = () => {
  if (BrowserFeatureDetector.getBrowserName() === "mobile safari" && BrowserFeatureDetector.getBrowserMajorVersion() === 9) {
    const version = Number(
      BrowserFeatureDetector.getOS().split(".")[0] +
        (BrowserFeatureDetector.getOS().split(".")[1] ? "." + BrowserFeatureDetector.getOS().split(".")[1] : ""),
    );
    return version >= 9.1;
  } else {
    return true;
  }
};

const isBrowserSupported = () => {
  if (!isIOS9Supported()) {
    return false;
  }
  const specsForBrowser = supportedBrowsers.filter((spec) => spec.name === BrowserFeatureDetector.getBrowserName());
  if (specsForBrowser.length) {
    const deviceSpecificSpec = specsForBrowser.find((spec) => spec.device && new RegExp(spec.device, "i").test(window.navigator.userAgent));
    const osSpecificSpec = specsForBrowser.find((spec) => spec.os && spec.os === BrowserFeatureDetector.getOS());
    if (osSpecificSpec) {
      return osSpecificSpec.minVersion <= BrowserFeatureDetector.getBrowserMajorVersion();
    } else {
      if (deviceSpecificSpec) {
        return deviceSpecificSpec.minVersion <= BrowserFeatureDetector.getBrowserMajorVersion();
      } else {
        const noDeviceSpec = specsForBrowser.find((spec) => !spec.device);
        if (noDeviceSpec) {
          return noDeviceSpec.minVersion <= BrowserFeatureDetector.getBrowserMajorVersion();
        } else {
          return false;
        }
      }
    }
  } else {
    return false;
  }
};

export const SupportedBrowserHelper = {
  isBrowserSupported,
};
